import './App.css';
import AdminApp from './admin/AdminApp';
import ClientApp from './client/ClientApp';

function App() {
  const isAdminRoute = window.location.pathname.startsWith('/admin');

  return isAdminRoute ? <AdminApp /> : <ClientApp />;
}

export default App;
